/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GradingConfigSnapshotResponseEvalDimensions } from './gradingConfigSnapshotResponseEvalDimensions';
import type { PerformanceLevelConfig } from './performanceLevelConfig';
import type { RubricDimensionOutput } from './rubricDimensionOutput';
import type { GradingConfigSnapshotResponseDefaultFormalParams } from './gradingConfigSnapshotResponseDefaultFormalParams';
import type { GradingConfigSnapshotResponseGradeProjector } from './gradingConfigSnapshotResponseGradeProjector';
import type { GradingConfigSnapshotResponseTaskGradeProjectors } from './gradingConfigSnapshotResponseTaskGradeProjectors';

/**
 * Sealed grading configuration captured at first evaluation write.
 */
export interface GradingConfigSnapshotResponse {
  evalDimensions?: GradingConfigSnapshotResponseEvalDimensions;
  performanceLevels?: PerformanceLevelConfig[];
  defaultFormalDimension: RubricDimensionOutput;
  defaultFormalParams?: GradingConfigSnapshotResponseDefaultFormalParams;
  gradeProjector?: GradingConfigSnapshotResponseGradeProjector;
  taskGradeProjectors?: GradingConfigSnapshotResponseTaskGradeProjectors;
}
